// Shared client contract for the member's appointment list. The Appointments page, both home tiles
// (`@internal/telemedicine`) and the Carrot Plan card (`@internal/consumer`) read it, and this is
// the only module both packages can reach — consumer cannot import telemedicine.
//
// Reached by subpath and NOT re-exported from `../index.ts`: the root pulls in `react-intl`. Keep
// this module import-free.

export const APPOINTMENTS_QUERY_KEY = ["telemedicine.getAppointments"] as const

// Also bounds `refetchOnWindowFocus`. Without it the surfaces share a cache slot and still make one
// request each, since react-query refetches a stale entry per observer.
export const APPOINTMENTS_SHARED_STALE_MS = 60 * 1000

/**
 * Whether a booked visit is over. "Scheduled" upstream means "not closed out by the provider", not
 * "still to come", so a finished visit stays `scheduled` indefinitely.
 *
 * ⚠ THE BFF AND THE CLIENT BOTH RUN THIS. The BFF drops an ended visit so a stale cache cannot
 * paint one; the client re-applies it as time passes so an open tab retires the visit on the
 * crossing. Neither covers the other's case.
 *
 * On `endTime`, not `startTime`, so a visit happening right now is still upcoming.
 *
 * ⚠ INCLUSIVE AT `endTime`. `useNow` fires its one-shot AT that instant, so an exclusive `<` would
 * answer "not ended" on the very render the timer scheduled, and with no crossing left to arm the
 * visit would never leave the list.
 */
export const hasEnded = (endTime: string, now: Date): boolean => Date.parse(endTime) <= now.getTime()
